import React from 'react'
import { Route, Routes } from 'react-router-dom';

import MobileBarQuotation from '../quotation/mobile-bar/MobileBarQuotation';
import UpdateMobileBar from '../quotation/mobile-bar/UpdateMobileBar';
import ViewQuotation from '../quotation/mobile-bar/ViewQuotation';
import UpdateCaterer from '../quotation/caterer/UpdateCaterer';
import CatererQuotation from '../quotation/caterer/CatererQuotation';
import ViewCaterer from '../quotation/caterer/ViewCaterer';

const QuotationRoutes = () => {
    return (
        <>
            <Routes>
                <Route path="/mobile-bar-quotation" element={<MobileBarQuotation />} />
                <Route path="/update-mobile-bar" element={<UpdateMobileBar />} />
                <Route path="/view-mobile-bar" element={<ViewQuotation />} />

                <Route path="/caterer-quotation" element={<CatererQuotation />} />
                <Route path="/update-caterer" element={<UpdateCaterer />} />
                <Route path="/view-caterer" element={<ViewCaterer />} />
            </Routes>
        </>
    )
}

export default QuotationRoutes;